export const remainingMemberPasses = (membershipCount, purchasedCount) => {
  return Math.max(0, Number(membershipCount || 0) - Number(purchasedCount || 0));
};

export const dailyPassTotal = (product, quantity, remainingPasses) => {
  const memberQuantity = Math.min(quantity, Math.max(0, remainingPasses));
  const memberPrice = product.coPrice != null ? Number(product.coPrice) : Number(product.price);
  return Math.round((memberQuantity * memberPrice + (quantity - memberQuantity) * Number(product.price)) * 100) / 100;
};

export const repriceDailyPassSelection = (selection, products, membershipCount, purchasedCounts) => {
  const next = { ...selection };
  (products || []).forEach((product) => {
    const picked = next[product.id];
    if (picked != null) {
      next[product.id] = {
        ...picked,
        code: product.code,
        price: dailyPassTotal(product, picked.qty, remainingMemberPasses(membershipCount, purchasedCounts[product.id])),
      };
    }
  });
  return next;
};
